export default {
  state: {
    messageAlert: '',
    isShowMessage: false
  },
  actions: {
    setMessage ({ commit }, payload) {
      commit('SET_MESSAGE', payload)
    },
    closeMessage ({ commit }) {
      commit('CLOSE_MESSAGE', false)
    }
},
  getters: {
    messageAlert: (state) => state.messageAlert,
    isShowMessage: (state) => state.isShowMessage
  },
  mutations: {
    SET_MESSAGE (state, value) {
      state.isShowMessage = true
      state.messageAlert = value
      setTimeout(() => { state.isShowMessage = false }, 3000)
    },
    CLOSE_MESSAGE (state, value) {
      state.isShowMessage = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/messageState/index.js